<template>
  <div class="document">
    <!-- TO DO create component for confirmation window - NQD-782-->
    <template>
      <div class="modal is-active"
        role="dialog"
        :aria-label="userAction.actionConfirmHeader"
        v-if="showModal"
      >
        <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title">
                {{ this.userAction.actionConfirmHeader }}
              </p>
              <button
                class="icon is-right"
                @click.prevent="toggleModal()"
                ref="closeIcon"
              >
                <font-awesome-icon
                  title="Close"
                  :icon="['fal', 'times']"
                />
              </button>
            </header>
            <section class="modal-card-body">
              <div class="modal-body">
                {{ this.userAction.actionConfirmMessage }}
                <br/>
                <br/>
              </div>
              <div class="update-box">
                <button
                  @click.prevent="toggleModal()"
                  :class="{ disabled: loading }"
                  class="button button-link has-underline"
                  :disabled="loading"
                  type="button"
                >
                  Cancel
                </button>
              <button
                class="button is-primary"
                @click="processUserAction()"
                :disabled="loading"
              >
                {{ this.userAction.actionConfirmButtonText }}
              </button>
            </div>
          </section>
        </div>
      </div>
    </template>
    <div class="card-container">
      <div class="card-content">
        <div class="card--heading is-flex">
          <div class="card-cell flex-direction--column">
            <div class="card-cell--title">
              Submission Record
            </div>
            <div class="has-text-left">
              <div class="card-cell--body is-size-4">
                <span v-if="nearMatch.pidSubmission.firstName">
                  {{ nearMatch.pidSubmission.firstName }}
                </span>
                <span v-if="nearMatch.pidSubmission.middleName &&
                  getFieldEnabledForPersonType('MIDDLE_NAME', 'ASSIGN',
                    nearMatch.pidSubmission.personType)">
                  {{ nearMatch.pidSubmission.middleName }}
                </span>
                <span v-if="nearMatch.pidSubmission.lastName">
                  {{ nearMatch.pidSubmission.lastName }}
                </span>
              </div>
            </div>
            <div class="has-text-left">
              <div v-if="nearMatch.pidBatchDistrictSchoolAssociation[0].district">
                <strong>
                  {{ nearMatch.pidBatchDistrictSchoolAssociation[0].district.location.name }}
                </strong>
                <span class="is-italic has-text-grey-light has-text-weight-light">
                  ({{ nearMatch.pidBatchDistrictSchoolAssociation[0].districtCode }})
                </span>
              </div>
              <div v-else>
                -
              </div>
              <div v-if="nearMatch.pidBatchDistrictSchoolAssociation[0].school">
                <strong>
                  {{ nearMatch.pidBatchDistrictSchoolAssociation[0].school.location.name }}
                </strong>
                <span class="is-italic has-text-grey-light has-text-weight-light">
                  ({{ nearMatch.pidBatchDistrictSchoolAssociation[0].schoolCode }})
                </span>
              </div>
              <div v-else>
                -
              </div>
            </div>
          </div>
          <div class="card-cell flex-direction--column border--left">
            <div class="has-text-left">
              <span class="card-heading-label has-text-grey">
                {{ getFieldLabelByPersonType('DATE_OF_BIRTH', 'ASSIGN', nearMatch.pidSubmission.personType) }}:
              </span>
              <span class="card-heading-value">
                {{ formatDate(nearMatch.pidSubmission.dateOfBirth) || '-' }}
              </span>
            </div>
            <div class="has-text-left"
              v-if="getFieldEnabledForPersonType('GRADE_CODE', 'ASSIGN', nearMatch.pidSubmission.personType)">
              <span class="card-heading-label has-text-grey">
                {{ getFieldLabelByPersonType('GRADE_CODE', 'ASSIGN', nearMatch.pidSubmission.personType) }}:
              </span>
              <span class="card-heading-value">
                {{ nearMatch.pidSubmission.gradeCode || '-' }}
              </span>
            </div>
            <div class="has-text-left"
              v-if="getFieldEnabledForPersonType('LOCAL_STUDENT_ID', 'ASSIGN',
                nearMatch.pidSubmission.personType)">
              <span class="card-heading-label has-text-grey">
                {{ getFieldLabelByPersonType('LOCAL_STUDENT_ID', 'ASSIGN', nearMatch.pidSubmission.personType) }}:
              </span>
              <span class="card-heading-value">
                {{ nearMatch.pidSubmission.localStudentId || '-' }}
              </span>
            </div>
          </div>
          <div class="card-cell flex-direction--column border--left">
            <div class="has-text-left"
              v-if="getFieldEnabledForPersonType('RACE_ETHNIC_CODE', 'ASSIGN', nearMatch.pidSubmission.personType)">
              <span class="card-heading-label has-text-grey">
                {{ getFieldLabelByPersonType('RACE_ETHNIC_CODE', 'ASSIGN', nearMatch.pidSubmission.personType) }}:
              </span>
              <span class="card-heading-value">
                {{ mapRace(nearMatch.pidSubmission.raceEthnicCode) || '-' }}
              </span>
            </div>
            <div class="has-text-left">
              <span class="card-heading-label has-text-grey">
                {{ getFieldLabelByPersonType('GENDER_CODE', 'ASSIGN', nearMatch.pidSubmission.personType) }}:
              </span>
              <span class="card-heading-value">
                {{ mapGender(nearMatch.pidSubmission.genderCode) || '-' }}
              </span>
            </div>
            <div class="has-text-left"
              v-if="getFieldEnabledForPersonType('SOCIAL_SECURITY_NUMBER', 'ASSIGN', nearMatch.pidSubmission.personType)">
              <span class="card-heading-label has-text-grey">
                {{ getFieldLabelByPersonType('SOCIAL_SECURITY_NUMBER', 'ASSIGN', nearMatch.pidSubmission.personType) }}:
              </span>
              <span class="card-heading-value" v-if="nearMatch.pidSubmission.socialSecurityNumber">
                {{ formatSsn(nearMatch.pidSubmission.socialSecurityNumber) }}
              </span>
              <span class="card-heading-value" v-else>
                -
              </span>
            </div>
          </div>
          <div class="card-cell border--left flex-align--center">
            <div class="padding-right">
              <vc-donut :size="60" :sections="[
                { value: roundmatchPercent - 1, color: '#215E97' },
                { value: 1, color: '#FFFFFF' },
                { value: 99 - roundmatchPercent, color: '#C8C8C8' },
                { value: 1, color: '#FFFFFF' },]">
                <h1 class="percent-label">
                  {{ roundmatchPercent }}%
                </h1>
              </vc-donut>
            </div>
            <div class="has-text-grey">
              <div>
                Max
              </div>
              <div>
                Match
              </div>
              <div>
                Score
              </div>
            </div>
          </div>
          <div class="card-cell border--left flex-align--center">
            <div class="has-text-weight-bold is-size-3 padding-right">
              {{ potentialNearMatches }}
            </div>
            <div class="has-text-grey">
              <div>
                Potential
              </div>
              <div>
                Matches
              </div>
            </div>
          </div>
          <div
            class=
              "card-cell
              border--left
              flex-align--center
              flex-justify--end">
            <button class="button button-link"
              @click="toggleExpand"
            >
              <font-awesome-icon
                style="font-size: 1.5rem;"
                class="is-primary"
                v-if="!isExpanded"
                :icon="['far', 'caret-down']"
                title="Expand"
                size="lg"
              />
              <font-awesome-icon
                style="font-size: 1.5rem;"
                class="is-primary"
                v-else
                :icon="['far', 'caret-up']"
                title="Collapse"
                size="lg"
              />
            </button>
            <a class="margin--left"
              v-if="activeResolveMenu.length && !showModal"
            >
              <es-menu
                :setValues="activeResolveMenu"
                @callMenuAction="callMenuAction"
                ref="esMenuEllipsisRef"
              />
            </a>
            <router-link
              :to="{
                name: 'pidCompareMatches',
                params: { nearMatchId: nearMatch.pidSubmissionId }
              }"
              class="margin--left"
            >
              <font-awesome-icon
                style="font-size: 1.7rem;"
                class="is-primary"
                :icon="['far', 'angle-double-right']"
                :title="`Compare ${properties['SYSTEM_LABEL-NEARMATCH']}(s/es)`"
                size="lg"
              />
            </router-link>
          </div>
      </div>
      <div class="card--body" v-if="isExpanded">
        <div class="has-text-left has-text-weight-bold">
          Potential Matches to Master Data
        </div>
        <div>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th></th>
              <th>
                Person Name
              </th>
              <th>
                Location
              </th>
              <th>
                {{ getFieldLabelByPersonType('DATE_OF_BIRTH', 'ASSIGN',
                nearMatch.pidSubmission.personType) }}
              </th>
              <th v-if="getFieldEnabledForPersonType('GRADE_CODE', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                {{ getFieldLabelByPersonType('GRADE_CODE', 'ASSIGN',
                nearMatch.pidSubmission.personType) }}
              </th>
              <th v-if="getFieldEnabledForPersonType('LOCAL_STUDENT_ID', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                {{ getFieldLabelByPersonType('LOCAL_STUDENT_ID', 'ASSIGN',
                nearMatch.pidSubmission.personType) }}
              </th>
              <th v-if="getFieldEnabledForPersonType('RACE_ETHNIC_CODE', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                {{ getFieldLabelByPersonType('RACE_ETHNIC_CODE', 'ASSIGN',
                nearMatch.pidSubmission.personType) }}
              </th>
              <th>
                {{ getFieldLabelByPersonType('GENDER_CODE', 'ASSIGN',
                nearMatch.pidSubmission.personType) }}
              </th>
              <th v-if="getFieldEnabledForPersonType('SOCIAL_SECURITY_NUMBER', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                {{ getFieldLabelByPersonType('SOCIAL_SECURITY_NUMBER', 'ASSIGN',
                nearMatch.pidSubmission.personType) }}
              </th>
              <th>
                Match Score
              </th>
              <th class="has-text-right">
                Actions
              </th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="100%" style="text-align: center">
                <es-loader style="margin: 2rem"/>
              </td>
            </tr>
          </tbody>
          <tbody v-else-if="nearMatch.pidMatchTransDetail.response.potentialMatches !== null">
            <tr
              v-for="potentialMatch in nearMatch.pidMatchTransDetail.response.potentialMatches"
              :key="potentialMatch.id"
            >
              <td class="padding--none">
                <es-near-match/>
              </td>
              <td>
                <div>
                    {{ getMasterDataElement('firstName', potentialMatch.matchedObject.id) }}
                    <div v-if="getFieldEnabledForPersonType('MIDDLE_NAME', 'ASSIGN',
                    nearMatch.pidSubmission.personType)">
                      {{ getMasterDataElement('middleName', potentialMatch.matchedObject.id) }}
                    </div>
                    {{ getMasterDataElement('lastName', potentialMatch.matchedObject.id) }}
                </div>
                <div>
                  <span class="is-italic has-text-grey-light" v-if="potentialMatch.id">
                    {{ formatStateID(potentialMatch.id) }}
                  </span>
                  <span v-else>
                    -
                  </span>
                </div>
              </td>
              <td>
                <div>
                  <span>
                    {{ getDistrictName(potentialMatch.matchedObject.id) }}
                  </span>
                  <span class="is-italic has-text-grey-light">
                    ({{ getMasterDataElement('districtCode', potentialMatch.matchedObject.id) }})
                  </span>
                </div>
                <div>
                  <span>
                    {{ getSchoolName(potentialMatch.matchedObject.id) }}
                  </span>
                  <span class="is-italic has-text-grey-light">
                     ({{ getMasterDataElement('schoolCode', potentialMatch.matchedObject.id) }})
                  </span>
                </div>
              </td>
              <td>
                <span v-if="getMasterDataElement('dateOfBirth', potentialMatch.matchedObject.id)">
                  {{ displayDOBFormat(getMasterDataElement('dateOfBirth',
                    potentialMatch.matchedObject.id)) }}
                </span>
              </td>
              <td v-if="getFieldEnabledForPersonType('GRADE_CODE', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                {{ getMasterDataElement('gradeCode', potentialMatch.matchedObject.id) }}
              </td>
              <td v-if="getFieldEnabledForPersonType('LOCAL_STUDENT_ID', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                {{ getMasterDataElement('localId', potentialMatch.matchedObject.id) }}
              </td>
              <td v-if="getFieldEnabledForPersonType('RACE_ETHNIC_CODE', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                <span v-if="getMasterDataElement('raceEthnicCode',
                  potentialMatch.matchedObject.id)">
                  {{ mapRace(getMasterDataElement('raceEthnicCode',
                    potentialMatch.matchedObject.id)) }}
                </span>
              </td>
              <td>
                <span v-if="getMasterDataElement('genderCode', potentialMatch.matchedObject.id)">
                  {{ mapGender(getMasterDataElement('genderCode',
                    potentialMatch.matchedObject.id)) }}
                </span>
              </td>
              <td v-if="getFieldEnabledForPersonType('SOCIAL_SECURITY_NUMBER', 'ASSIGN',
              nearMatch.pidSubmission.personType)">
                <span v-if="getMasterDataElement('socialSecurityNumber',
                  potentialMatch.matchedObject.id)">
                  {{ formatSsn(getMasterDataElement('socialSecurityNumber',
                    potentialMatch.matchedObject.id)) }}
                </span>
              </td>
              <td>
                <div class="is-flex justify-content--start">
                  <vc-donut
                    :size="50"
                    :sections="[
                    { value: potentialMatch.percent - 1, color: '#215E97' },
                    { value: 1, color: '#FFFFFF' },
                    { value: 99 - potentialMatch.percent, color: '#C8C8C8'},
                    { value: 1, color: '#FFFFFF' }]"
                  >
                    <h2 class="percent-label is-size-6">
                      {{ potentialMatch.percent }}%
                    </h2>
                  </vc-donut>
                </div>
              </td>
              <td class="has-text-right">
                <a v-if="userCanPerformMatch"
                  tabindex="0" role="button"
                  @click="userAction.actionId = potentialMatch.id;
                    callMenuAction(
                      {
                        doAction: 'performMatch',
                        refName: `refMatchLink${potentialMatch.id}`
                      }
                    )"
                  @keypress.enter.prevent="userAction.actionId = potentialMatch.id;
                    callMenuAction(
                      {
                        doAction: 'performMatch',
                        refName: `refMatchLink${potentialMatch.id}`
                      }
                    )"
                  :ref="`refMatchLink${potentialMatch.id}`"
                >
                  <font-awesome-icon style="font-size: 1.4rem;"
                    class="is-primary"
                    :icon="['far', 'check']"
                    size="lg"
                    title="Match"
                  />
                </a>
                <router-link
                  :to="{
                    name: 'pidCompareMatches',
                    params: { nearMatchId: nearMatch.pidSubmissionId }
                  }"
                  class="margin--left"
                >
                  <font-awesome-icon style="font-size: 1.7rem;"
                    class="is-primary"
                    :icon="['far', 'angle-double-right']"
                    size="lg"
                    :title="`Compare ${properties['SYSTEM_LABEL-NEARMATCH']}(s/es)`"
                  />
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
import axios from 'axios';
import Donut from 'vue-css-donut-chart';
import EsLoader from '@/components/EsLoader.vue';
import EsNearMatch from '@/components/EsNearMatch.vue';
import EsMenu from '@/components/EsMenu.vue';
import FieldLabels from '@/mixins/FieldLabels';
import 'vue-css-donut-chart/dist/vcdonut.css';
import PermissionManager from '@/mixins/PermissionManager';
import NotificationManager from '@/mixins/NotificationManager';
import DateUtils from '@/mixins/DateUtils';
import StateIdUtils from '@/mixins/StateIdUtils';
import AccessibilityUtils from '@/mixins/AccessibilityUtils';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
  faBan,
  faCheck,
  faCaretDown,
  faCaretUp,
} from '@fortawesome/pro-regular-svg-icons';

library.add(
  faAngleDoubleRight,
  faBan,
  faCheck,
  faCaretDown,
  faCaretUp,
);

Vue.use(Donut);

export default {
  mixins: [
    FieldLabels,
    StateIdUtils,
    PermissionManager,
    DateUtils,
    NotificationManager,
    AccessibilityUtils,
  ],
  emits: ['refresh'],
  props: {
    loadedDistrictSchools: {
      type: Object,
    },
    lowerBound: {
      type: String,
      required: false,
    },
    matchPercent: {
      type: Number,
      required: false,
    },
    nearMatch: {
      type: Object,
      required: true,
    },
    upperBound: {
      type: String,
      required: false,
    },
  },
  components: {
    EsLoader,
    EsNearMatch,
    EsMenu,
  },
  data() {
    return {
      isExpanded: false,
      districts: [],
      loading: null,
      schools: [],
      showModal: false,
      masterData: {},
      noMatchResult: null,
      userAction: {
        actionConfirmButtonText: '',
        actionConfirmMessage: '',
        actionConfirmHeader: '',
        actionMethod: '',
        actionId: '',
      },
      refEle: '',
    };
  },
  async created() {
    await this.onLoad();
  },
  computed: {
    ...mapGetters({
      hasDistrictSchoolPermission: 'hasDistrictSchoolPermission',
    }),
    ...mapGetters('lookups', [
      'activeRaces',
      'activeGenders',
    ]),
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldLabelByPersonType',
    ]),
    potentialNearMatches() {
      let result = null;
      if (this.nearMatch.pidMatchTransDetail.response.potentialMatches) {
        result = this.nearMatch.pidMatchTransDetail.response.potentialMatches.length;
      }
      return result;
    },
    roundmatchPercent() {
      return Math.max(...this.nearMatch.pidMatchTransDetail.response.potentialMatches
        .map(match => match.percent));
    },
    activeResolveMenu() {
      return this.resolveMenu.filter(item => !item.isHidden);
    },
    resolveMenu() {
      const items = [];
      if ([6].includes(this.nearMatch.transStatus)) {
        items.push({
          id: 1,
          description: 'Cancel Submission Record',
          isHidden: !this.hasModule('PRSID:MATCH:RESOLVENM:CANCEL'),
          isInternal: true,
          callMenuAction: 'cancelSubmission',
        });
        items.push({
          id: 2,
          description: this.properties['BUTTON_LABEL-CREATE_NEW'],
          isHidden: !this.userCanPerformNoMatch,
          isInternal: true,
          callMenuAction: 'performNoMatch',
        });
      }
      return items;
    },
    cancelSubmissionMessage() {
      return 'Are you sure you want to cancel this submission record?';
    },
    noMatchMessage() {
      return `Are you sure you want to select ${this.properties['BUTTON_LABEL-CREATE_NEW']} and create a new identifier?`;
    },
    matchMessage() {
      return `Are you sure you want to make a "${this.properties['BUTTON_LABEL-ASSIGN_EXISTING']}" decision for the submission record?`;
    },

    hasNearMatchSsnSameResolution() {
      return this.nearMatch.pidMatchTransDetail.response.resolutionReason === 'NEAR_MATCH_NO_DEMOGRAPHIC_MATCHES_BUT_MATCHED_SSNS';
    },
    userCanPerformMatch() {
      const hasMatchPermission = this.hasDistrictSchoolPermission(this.matchPermission('PRSID:MATCH:RESOLVENM:MATCHDEC:ASSNEXIST'));
      const hasSsnSamePermission = this.hasDistrictSchoolPermission(this.matchPermission('PRSID:MATCH:RESOLVENM:ASSIGN:SSNSAME'));
      return this.hasNearMatchSsnSameResolution
        ? hasSsnSamePermission
        : hasMatchPermission;
    },
    hasIdRelatedNoMatchPermission() {
      if (this.nearMatch.pidSubmission.stateStudentId) {
        return this.hasDistrictSchoolPermission(this.matchPermission('PRSID:MATCH:RESOLVENM:CREATEID:IDPRESENT'));
      }
      return this.hasDistrictSchoolPermission(this.matchPermission('PRSID:MATCH:RESOLVENM:CREATEID:IDNOTPRESENT'));
    },
    verifyNoMatchSsnsame() {
      return this.hasNearMatchSsnSameResolution
        ? this.hasDistrictSchoolPermission(this.matchPermission('PRSID:MATCH:RESOLVENM:CREATEID:SSNSAME'))
        : true;
    },
    userCanPerformNoMatch() {
      const hasSsnSamePermissionForCreate = this.hasDistrictSchoolPermission(this.matchPermission('PRSID:MATCH:RESOLVENM:CREATEID:SSNSAME'));
      return this.hasNearMatchSsnSameResolution
        ? hasSsnSamePermissionForCreate
        : this.hasIdRelatedNoMatchPermission;
    },
    // TO DO add this code to common js file used by this panel and CompareMatches
  },
  methods: {
    ...mapActions([
      'getDistrict',
      'getSchool',
    ]),
    async onLoad() {
      try {
        this.loading = true;
        await this.getDataFromMaster();
      } catch (error) {
        if (error.response.status === 500) {
          this.apiMsg = 'Network Error';
        } else {
          this.apiMsg = `${error.response.data.message}`;
        }
        this.showError(this.apiMsg);
      } finally {
        this.loading = false;
      }
    },
    async getDataFromMaster() {
      try {
        const pidSubmissionId = this.getPotentialMatchSubmissionIds(this.nearMatch);
        const params = new URLSearchParams();
        params.append('submissionId', pidSubmissionId);
        const res = await axios.get('person/potentialmatches', { params });
        this.masterData = new Map();
        res.data.forEach(student => this.masterData.set(student.stateStudentId, student));
      } catch (error) {
        if (error.response.status === 500) {
          this.apiMsg = 'Network Error';
        } else {
          this.apiMsg = `${error.response.data.message}`;
        }
        this.showError(this.apiMsg);
      } finally {
        this.showModal = false;
      }
    },
    getPotentialMatchSubmissionIds(aNearMatch) {
      return aNearMatch.pidMatchTransDetail.pidSubmissionId;
    },
    getMasterDataElement(elementName, stateStudentId) {
      const aStudent = this.masterData.get(stateStudentId);
      if (!aStudent) {
        return '';
      }
      const aProperty = Object.getOwnPropertyDescriptor(aStudent, elementName);
      return (aProperty) ? aProperty.value : '';
    },
    callMenuAction(result) {
      this.toggleModal(result.doAction, result.refName);
    },
    buildDistrictSchoolApi(code) {
      const districtCode = code.substring(0, code.indexOf(':'));
      const schoolCode = code.substring(code.indexOf(':') + 1, code.length);

      return `districts/${districtCode}/schools/${schoolCode}`;
    },
    districtCodeFromSchoolCode(schoolCode) {
      return schoolCode.substring(0, 3);
    },
    formatDate(date) {
      const year = date.substring(0, 4);
      const month = date.substring(5, 7);
      const day = date.substring(8, 10);

      return `${month} /  ${day}  /  ${year}`;
    },
    formatSsn(ssn) {
      if (!this.hasDistrictSchoolPermission(this.matchPermission('PRSID:PRPRF:SSN:VIEW'))) {
        return '\u00A0';
      }
      if (ssn && ssn.includes('*')) {
        return ssn;
      }
      const numbers = ssn.replace(/[^0-9]/g, '');
      if (numbers.length === 9) {
        return `${numbers.substr(0, 3)} - ${numbers.substr(3, 2)} - ${numbers.substr(5, 4)}`;
      }
      return null;
    },
    getDistrictName(potentialMatchId) {
      const object = this.getDistrictSchoolObject(this.masterData.get(potentialMatchId));
      if (object) {
        return object.districtLocation.name;
      }
      return null;
    },
    getDistrictSchoolObject(student) {
      const { districtCode, schoolCode } = student;
      const key = `${districtCode}:${schoolCode}`;

      return this.loadedDistrictSchools[key];
    },
    getSchoolName(potentialMatchId) {
      const object = this.getDistrictSchoolObject(this.masterData.get(potentialMatchId));
      if (object) {
        return object.location.name;
      }
      return null;
    },
    async loadDistrictsAndSchools() {
      try {
        this.loading = true;

        // get unique set of district and school codes for each near match
        const districtSchoolCodes = new Set(
          this.nearMatch.pidMatchTransDetail.response.potentialMatches
            .map(potentialMatch => `${potentialMatch.matchedObject.districtCode}:${potentialMatch.matchedObject.schoolCode}`),
        );

        // check to see if these code are already in the Set
        [...districtSchoolCodes].forEach((code) => {
          if (this.loadedDistrictSchools[code]) districtSchoolCodes.delete(code);
        });

        // build promises to get district and school info
        const DistrictSchoolResponses = await Promise.all(
          [...districtSchoolCodes].map(code => axios.get(this.buildDistrictSchoolApi(code))),
        );

        // use the response from above and push them into prop
        DistrictSchoolResponses.forEach((districtSchool) => {
          const { districtCode, code } = districtSchool.data;
          const key = `${districtCode}:${code}`;
          this.loadedDistrictSchools[key] = districtSchool.data;
        });
      } catch (e) {
        // what do we want to show on error?
      } finally {
        this.loading = false;
      }
    },
    matchPermission(permission) {
      return {
        permission,
        districtCode: this.nearMatch.districtCode,
        schoolCode: this.nearMatch.schoolCode,
      };
    },
    mapGender(genderCode) {
      if (genderCode && genderCode.includes('*')) {
        return genderCode;
      }
      const genders = this.activeGenders.find(gender => gender.code === genderCode);
      if (genders) {
        return genders.description;
      }
      return null;
    },
    mapRace(raceCode) {
      if (raceCode && raceCode.includes('*')) {
        return raceCode;
      }
      const races = this.activeRaces.find(race => race.code === raceCode);
      if (races) {
        return races.description;
      }
      return null;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.loadDistrictsAndSchools();
      }
    },
    showSuccess(message) {
      this.showNotification('success', Array.isArray(message) ? message : [message]);
    },
    showError(error) {
      this.showNotification('danger', Array.isArray(error) ? error : [error]);
    },
    getStateIdLabel() {
      const stateIdLabel = this.getFieldLabelByPersonType('STATE_STUDENT_ID', 'ASSIGN', this.nearMatch.pidSubmission.personType);
      return stateIdLabel;
    },
    async cancelSubmission() {
      try {
        this.loading = true;
        await axios.put(`personid/transactions/${this.nearMatch.pidSubmission.id}`,
          { command: 'CANCEL', originalPidSubmissionId: this.nearMatch.pidSubmission.id });
        this.showSuccess('The submission record has been canceled.');
      } catch (error) {
        if (error.response.status === 500) {
          this.apiMsg = 'Network Error';
        } else {
          this.apiMsg = `${error.response.data.message}`;
        }
        this.showError(this.apiMsg);
      } finally {
        this.showModal = false;
        this.loading = false;
        this.$emit('refresh');
      }
    },
    async performNoMatch() {
      try {
        this.loading = true;
        this.noMatchResult = await axios.put(`personid/transactions/${this.nearMatch.pidSubmission.id}`,
          { command: 'CREATE_NEW', originalPidSubmissionId: this.nearMatch.pidSubmission.id });
        if (this.noMatchResult && this.noMatchResult.data.newPersonIdAssigned) {
          this.showSuccess(`${this.properties['SYSTEM_LABEL-NEARMATCH']} Resolved: No Match [New ID Created: ${this.formatStateID(this.noMatchResult.data.newPersonIdAssigned)}]`);
        }
      } catch (error) {
        if (error.response.status === 500) {
          this.apiMsg = 'Network Error';
        } else {
          this.apiMsg = `${error.response.data.message}`;
        }
        this.showError(this.apiMsg);
      } finally {
        this.showModal = false;
        this.loading = false;
        this.$emit('refresh');
      }
    },
    async performMatch(actionId) {
      try {
        this.loading = true;
        await axios.put(`personid/transactions/${this.nearMatch.pidSubmission.id}`,
          {
            command: 'ASSIGN_ID',
            personIdForAssign: actionId,
            originalPidSubmissionId: this.nearMatch.pidSubmission.id,
            okToUpdatePersonForASSIGN_ID: true,
          });
        this.showSuccess(`${this.properties['SYSTEM_LABEL-NEARMATCH']} Resolved. Match Found (${this.getStateIdLabel()}: ${this.formatStateID(actionId)})`);
      } catch (error) {
        if (error.response.status === 500) {
          this.apiMsg = 'Network Error';
        } else {
          this.apiMsg = `${error.response.data.message}`;
        }
        this.showError(this.apiMsg);
      } finally {
        this.showModal = false;
        this.loading = false;
        this.$emit('refresh');
      }
    },
    toggleModal(action, refMatch) {
      this.userAction.actionMethod = action;
      if (action === 'cancelSubmission') {
        this.userAction.actionConfirmMessage = this.cancelSubmissionMessage;
        this.userAction.actionConfirmHeader = 'Cancel Submission Record';
        this.userAction.actionConfirmButtonText = 'Cancel Submission Record';
      } else if (action === 'performNoMatch') {
        this.userAction.actionConfirmMessage = this.noMatchMessage;
        this.userAction.actionConfirmHeader = 'Confirm Decision';
        this.userAction.actionConfirmButtonText = 'Yes Create a New ID';
      } else if (action === 'performMatch') {
        this.userAction.actionConfirmMessage = this.matchMessage;
        this.userAction.actionConfirmHeader = 'Confirm Decision';
        this.userAction.actionConfirmButtonText = `Yes Select ${this.properties['BUTTON_LABEL-ASSIGN_EXISTING']}`;
        this.userAction.actionMethod = 'performMatch';
      }
      this.showModal = !this.showModal;
      if (this.showModal) {
        this.$nextTick(() => {
          if (action === 'performMatch') {
            if (refMatch) {
              [this.refEle] = this.$refs[refMatch];
            }
          }
          if (this.$refs.closeIcon) {
            // Focus on close icon when modal opens
            this.$refs.closeIcon.focus();
          }
          this.modalTrapFocus();
        });
        this.$el.addEventListener('keydown', this.modalHandleEscKey);
      } else if (!this.showModal) {
        this.$nextTick(() => {
          if (this.refEle === '') {
            if (this.$refs.esMenuEllipsisRef.$refs.ellipsisRef) {
              this.refEle = this.$refs.esMenuEllipsisRef.$refs.ellipsisRef;
            }
          }
          if (this.refEle) {
            this.refEle.focus();
          }
          this.refEle = '';
        });
        this.$el.removeEventListener('keydown', this.modalHandleEscKey);
      }
    },
    processUserAction() {
      this[this.userAction.actionMethod](this.userAction.actionId);
    },
  },
};
</script>

<style lang="sass" scoped>
  .document
    margin-bottom: 1rem
  .card-container
    padding-top: 0.5rem
    overflow-x: auto
    max-width: 100%
  .card-content
    padding: 0
    display: inline-block
    min-width: max-content
    width: 100%
  .card--holder
    max-width: 100%
  .card--heading
    min-height:  70px
    .card-heading-label
      padding-right: 0.5rem
      font-size: 12px
    .card-heading-value
      font-size: 16px
      font-weight: 700
  .card--body
    padding: 1.5rem 4rem
    .table
      border-top: 1px solid #ccc
      border-collapse: collapse
  .card-cell
    padding: 0 1rem
    margin-bottom: 0.5rem
    flex: 1 0 auto
    display: flex
    justify-content: space-around
    .button-link
      padding-left: 0.5em;
      padding-right: 0.5em;
  .card-cell--title
    padding: 0.5rem 0
    color: #737373
    font-size: 12px
    text-align: left
  .border--left
    border-left: 1px solid #ccc
  .border--bottom
    border-bottom: 1px solid #ccc

  .padding-right
    padding-right: 1rem
  .margin--left
    margin-left: 1rem
  .margin-left--auto
    margin-left: auto
  .overflow--ellipsis
    overflow: hidden
    text-overflow: ellipsis
  .padding--none
    padding: 0px !important

  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
    a.disabled
      color: #999
      cursor:  default
      text-decoration:  none
      pointer-events: none
      &:hover
        text-decoration:  none
  // global
  .margin-left
    margin-left: 1rem

  .percent-label
    font-style: bold
    color: black
    font-size: 1.1rem
    font-weight: 800
    padding: .25rem 0 .25rem .15rem
</style>
